import { Link } from 'react-router-dom';

import { MessageCircleMore } from 'lucide-react';
import { Badge, DefaultTooltip } from 'twyne-new.ui';

import history from 'utils/history';

export const sweepFormatter = (cell, row, _, onlyText) => {
  const text = `#${row.sweepId} - ${row.CmsPost?.title}`

  if (onlyText) {
    return text
  }

  return <>
    <Link to={`/cms/sweep/${row.sweepId}`} target='_blank' className='twy-text-accent hover:underline'>
      {text}
    </Link>
  </>
}

export const winnerFormatter = (cell, row, _, onlyText) => {
  if (!cell || !row.sweepSubscription) {
    return 'No winner'
  }

  const { first_name, last_name } = row.sweepSubscription.userSession.user
  const name = `${first_name || ''} ${last_name || ''}`

  if (onlyText) {
    return name
  }

  return <DefaultTooltip DefaultTooltip content='Open winner details' triggerProps={{ asChild: true }}>
    <Link to={`/reports/sweep-winner/${row.subscriptionId}/${row.id}/winner`} className='twy-text-accent hover:underline'>
      {name}
    </Link>
  </DefaultTooltip>
}

export const winnerIconFormatter = (_, row) => {
  if (!row.winnerFound) {
    return null
  }

  return <>
    <DefaultTooltip content='Open winner details' triggerProps={{ asChild: true }}>
      <MessageCircleMore size={16} className='twy-text-accent cursor-pointer mr-2' onClick={() => history.push(`/reports/sweep-winner/${row.subscriptionId}/${row.id}/winner`)} />
    </DefaultTooltip>
  </>
}

const winnerStatusOptions = {
  fulfilled: {
    label: 'fulfilled',
    badge: 'success',
  },
  forfeited: {
    label: 'forfeited',
    badge: 'danger',
  },
  pending_contact: {
    label: 'pending-contact',
    badge: 'neutral',
  },
  pending_verification: {
    label: 'pending-verification',
    badge: 'warning',
  },
}

export const winnerStatusFormatter = (cell, row) => {
  const { label, badge } = winnerStatusOptions[cell] || {}
  if (!label || !badge || !row.winnerFound) {
    return '--'
  }

  return <Badge variant='light' color={badge}>{label}</Badge>
}

export const nullableFormatter = formatter => (cell, ...args) => {
  if (!cell) {
    return '--'
  }
  return formatter(cell, ...args)
}
